// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"_1IDj6tZCLv2RIOGRJc5Bnb"};